import * as i0 from '@angular/core';
import { Component, HostBinding, Input, ViewChild, forwardRef, EventEmitter, ViewEncapsulation, Output, ContentChildren, HostListener, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i2 from '@angular-mdl/popover';
import { MdlPopoverComponent, MdlPopoverModule } from '@angular-mdl/popover';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

const stringifyValue = (value) => {
    switch (typeof value) {
        case "number":
            return String(value);
        case "object":
            return JSON.stringify(value);
        default:
            return !!value ? String(value) : "";
    }
};

class MdlOptionComponent {
    constructor(changeDetectionRef) {
        this.changeDetectionRef = changeDetectionRef;
        // eslint-disable-next-line
        this.disabled = false;
        this.isOptionConatiner = true;
        this.multiple = false;
        this.selected = false;
        this.onSelect = Function.prototype;
    }
    get stringValue() {
        return stringifyValue(this.value);
    }
    select(event) {
        if (this.disabled) {
            event.stopPropagation();
            event.preventDefault();
        }
        else {
            this.onSelect(this.value);
        }
    }
    setMultiple(multiple) {
        this.multiple = multiple;
        this.changeDetectionRef.detectChanges();
    }
    updateSelected(value) {
        if (this.multiple) {
            this.selected =
                (value || [])
                    .map((v) => stringifyValue(v))
                    .indexOf(this.stringValue) !== -1;
        }
        else {
            this.selected = this.value === value;
        }
        // eslint-disable-next-line
        if (!this.changeDetectionRef.destroyed) {
            this.changeDetectionRef.detectChanges();
        }
    }
    ngAfterViewInit() {
        this.text = this.contentWrapper?.nativeElement.textContent.trim();
    }
}
MdlOptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlOptionComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
MdlOptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: MdlOptionComponent, selector: "mdl-option", inputs: { disabled: "disabled", value: "value" }, host: { properties: { "class.mdl-option--disabled": "this.disabled", "class.mdl-option__container": "this.isOptionConatiner" } }, viewQueries: [{ propertyName: "contentWrapper", first: true, predicate: ["contentWrapper"], descendants: true, static: true }], ngImport: i0, template: "<div\n    class=\"mdl-list__item\"\n    (click)=\"select($event)\"\n    [class.is-active]=\"selected\">\n\n  <div *ngIf=\"multiple\" class=\"mdl-list__item-secondary-action\">\n    <div class=\"mdl-checkbox is-upgraded\" [class.is-checked]=\"selected\">\n      <input type=\"checkbox\" class=\"mdl-checkbox__input\">\n      <span class=\"mdl-checkbox__label\"></span>\n      <span class=\"mdl-checkbox__focus-helper\"></span>\n      <span class=\"mdl-checkbox__box-outline\">\n        <span class=\"mdl-checkbox__tick-outline\"></span>\n      </span>\n    </div>\n  </div>\n\n  <div #contentWrapper class=\"mdl-list__item-primary-content\">\n    <ng-content></ng-content>\n  </div>\n\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: "mdl-option", template: "<div\n    class=\"mdl-list__item\"\n    (click)=\"select($event)\"\n    [class.is-active]=\"selected\">\n\n  <div *ngIf=\"multiple\" class=\"mdl-list__item-secondary-action\">\n    <div class=\"mdl-checkbox is-upgraded\" [class.is-checked]=\"selected\">\n      <input type=\"checkbox\" class=\"mdl-checkbox__input\">\n      <span class=\"mdl-checkbox__label\"></span>\n      <span class=\"mdl-checkbox__focus-helper\"></span>\n      <span class=\"mdl-checkbox__box-outline\">\n        <span class=\"mdl-checkbox__tick-outline\"></span>\n      </span>\n    </div>\n  </div>\n\n  <div #contentWrapper class=\"mdl-list__item-primary-content\">\n    <ng-content></ng-content>\n  </div>\n\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { disabled: [{
                type: HostBinding,
                args: ["class.mdl-option--disabled"]
            }, {
                type: Input
            }], 
        // eslint-disable-next-line
        value: [{
                type: Input,
                args: ["value"]
            }], contentWrapper: [{
                type: ViewChild,
                args: ["contentWrapper", { static: true }]
            }], isOptionConatiner: [{
                type: HostBinding,
                args: ["class.mdl-option__container"]
            }] } });

// eslint-disable-next-line no-shadow
var KEYS;
(function (KEYS) {
    KEYS[KEYS["tab"] = 9] = "tab";
    KEYS[KEYS["enter"] = 13] = "enter";
    KEYS[KEYS["escape"] = 27] = "escape";
    KEYS[KEYS["upArrow"] = 38] = "upArrow";
    KEYS[KEYS["downArrow"] = 40] = "downArrow";
    KEYS[KEYS["a"] = 65] = "a";
    KEYS[KEYS["b"] = 66] = "b";
    KEYS[KEYS["c"] = 67] = "c";
    KEYS[KEYS["d"] = 68] = "d";
    KEYS[KEYS["e"] = 69] = "e";
    KEYS[KEYS["f"] = 70] = "f";
    KEYS[KEYS["g"] = 71] = "g";
    KEYS[KEYS["h"] = 72] = "h";
    KEYS[KEYS["i"] = 73] = "i";
    KEYS[KEYS["j"] = 74] = "j";
    KEYS[KEYS["k"] = 75] = "k";
    KEYS[KEYS["l"] = 76] = "l";
    KEYS[KEYS["m"] = 77] = "m";
    KEYS[KEYS["n"] = 78] = "n";
    KEYS[KEYS["o"] = 79] = "o";
    KEYS[KEYS["p"] = 80] = "p";
    KEYS[KEYS["q"] = 81] = "q";
    KEYS[KEYS["r"] = 82] = "r";
    KEYS[KEYS["s"] = 83] = "s";
    KEYS[KEYS["t"] = 84] = "t";
    KEYS[KEYS["u"] = 85] = "u";
    KEYS[KEYS["v"] = 86] = "v";
    KEYS[KEYS["w"] = 87] = "w";
    KEYS[KEYS["x"] = 88] = "x";
    KEYS[KEYS["y"] = 89] = "y";
    KEYS[KEYS["z"] = 90] = "z";
})(KEYS || (KEYS = {}));
// eslint-disable-next-line
const keyboardEventKeyCode = ($event) => ($event.which || $event.charCode || $event.keyCode);
const keyboardEventKey = ($event) => $event.key || String.fromCharCode(keyboardEventKeyCode($event));
const isKey = ($event, ...keys) => keys.indexOf(keyboardEventKeyCode($event)) !== -1;
const isCharacterKey = ($event) => {
    const keyCode = keyboardEventKeyCode($event);
    return !!String.fromCharCode(keyCode) && keyCode >= 48 && keyCode <= 90;
};

const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
const toBoolean = (value) => value != null && `${value}` !== "false";
const randomId = () => {
    const S4 = () => 
    // eslint-disable-next-line
    (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    return S4() + S4();
};
const MDL_SELECT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // eslint-disable-next-line
    useExisting: forwardRef(() => MdlSelectComponent),
    multi: true,
};
class SearchableComponent {
    constructor() {
        this.searchQuery = "";
        this.clearTimeout = null;
    }
    // short search query will be cleared after 300 ms
    updateShortSearchQuery($event) {
        if (this.clearTimeout) {
            clearTimeout(this.clearTimeout);
        }
        this.clearTimeout = setTimeout(() => {
            this.searchQuery = "";
        }, 300);
        this.searchQuery += keyboardEventKey($event).toLowerCase();
    }
}
class MdlSelectComponent extends SearchableComponent {
    constructor(changeDetectionRef, elementRef) {
        super();
        this.changeDetectionRef = changeDetectionRef;
        this.elementRef = elementRef;
        this.disabled = false;
        this.autocomplete = false;
        this.label = "";
        this.placeholder = "";
        this.multiple = false;
        // eslint-disable-next-line
        this.change = new EventEmitter(true);
        // eslint-disable-next-line
        this.blur = new EventEmitter(true);
        this.inputChange = new EventEmitter(true);
        this.isMdlSelect = true;
        this.directionUp = false;
        this.text = "";
        this.focused = false;
        // eslint-disable-next-line
        this.model = null;
        this.textByValue = {};
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.misFloatingLabel = false;
        this.textfieldId = `mdl-textfield-${randomId()}`;
    }
    get isPlaceholder() {
        return !!this.placeholder;
    }
    get isFloatingLabel() {
        return this.misFloatingLabel;
    }
    set isFloatingLabel(value) {
        this.misFloatingLabel = toBoolean(value);
    }
    onKeyDown($event) {
        if (!this.disabled && this.popoverComponent?.isVisible && !this.multiple) {
            if (isKey($event, KEYS.upArrow)) {
                this.onArrow($event, -1);
            }
            else if (isKey($event, KEYS.downArrow)) {
                this.onArrow($event, 1);
            }
            else if (!this.autocomplete && isCharacterKey($event)) {
                this.onCharacterKeydown($event);
            }
        }
    }
    onKeyUp($event) {
        const inputField = $event.target;
        const inputValue = inputField.value;
        if (!this.multiple && isKey($event, KEYS.enter, KEYS.escape, KEYS.tab)) {
            this.searchQuery = "";
            if (isKey($event, KEYS.enter)) {
                this.setCurrentOptionValue();
            }
            else {
                inputField.value = this.text;
            }
            inputField.blur();
            this.popoverComponent?.hide();
        }
        else if (this.autocomplete &&
            !isKey($event, KEYS.downArrow, KEYS.upArrow)) {
            this.inputChange.emit(inputValue);
            this.searchQuery = inputValue;
        }
        $event.preventDefault();
    }
    ngAfterContentInit() {
        this.bindOptions();
        this.renderValue(this.model);
        this.optionComponents?.changes.subscribe(() => {
            this.bindOptions();
            this.renderValue(this.model);
        });
        this.popoverComponent?.onShow.subscribe(() => this.onOpen());
        this.popoverComponent?.onHide.subscribe(() => this.onClose());
    }
    ngAfterViewInit() {
        this.selectElement = this.elementRef.nativeElement;
        this.popoverElement = this.popoverComponent?.elementRef
            .nativeElement;
    }
    isDirty() {
        return Boolean(this.selectInput?.nativeElement.value);
    }
    // rebind options and reset value in connected select
    reset(resetValue = true) {
        if (resetValue && !this.isEmpty()) {
            this.model = this.multiple ? [] : "";
            this.onChange(this.model);
            this.change.emit(this.model);
            this.renderValue(this.model);
        }
    }
    toggle($event) {
        if (!this.disabled) {
            $event.stopPropagation();
            this.popoverComponent?.toggle($event);
        }
    }
    onFocus($event) {
        if (!this.popoverComponent?.isVisible) {
            setTimeout(() => {
                this.popoverComponent?.show($event);
                this.selectInput?.nativeElement.focus();
            }, 200);
        }
    }
    onInputFocus() {
        if (this.autocomplete) {
            this.selectInput?.nativeElement.select();
        }
    }
    writeValue(value) {
        if (this.multiple) {
            this.model = this.model || [];
            if (!value || this.model === value) {
                // skip ngModel update when undefined value or multiple selects initialized with same array
            }
            else if (Array.isArray(value)) {
                this.model = value;
            }
            else if (this.model
                .map((v) => stringifyValue(v))
                .indexOf(stringifyValue(value)) !== -1) {
                this.model = [
                    ...this.model.filter((v) => stringifyValue(v) !== stringifyValue(value)),
                ];
            }
            else if (!!value) {
                this.model = [...this.model, value];
            }
        }
        else {
            this.model = value;
        }
        this.renderValue(this.model);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    setCurrentOptionValue() {
        const currentOption = this.getCurrentOption();
        const autoSelectedValue = this.getAutoSelection();
        const value = autoSelectedValue || (currentOption ? currentOption.value : this.model);
        this.resetText();
        if (!isEqual(this.model, value)) {
            this.writeValue(value);
            this.change.emit(value);
            this.onChange(this.model);
        }
    }
    resetText() {
        this.text = this.selectInput?.nativeElement.value;
        this.changeDetectionRef.detectChanges();
    }
    getCurrentOption() {
        return this.optionComponents
            ? this.optionComponents.find((option) => option.selected)
            : null;
    }
    onCharacterKeydown($event) {
        this.updateShortSearchQuery($event);
        const autoSelectedValue = this.getAutoSelection();
        if (autoSelectedValue) {
            this.onSelect(autoSelectedValue);
        }
        $event.preventDefault();
    }
    getAutoSelection() {
        const filteredOptions = this.optionComponents
            ?.filter(({ disabled }) => !disabled)
            .filter((option) => option.text?.toLowerCase().startsWith(this.searchQuery));
        const selectedOption = this.optionComponents?.find((option) => option.selected);
        if (filteredOptions && filteredOptions.length > 0) {
            const selectedOptionInFiltered = selectedOption && filteredOptions.indexOf(selectedOption) !== -1;
            if (!selectedOptionInFiltered && !filteredOptions[0].selected) {
                return filteredOptions[0].value;
            }
        }
        return null;
    }
    onArrow($event, offset) {
        const arr = this.optionComponents
            ?.toArray()
            .filter(({ disabled }) => !disabled);
        if (!arr) {
            return;
        }
        let optionForSelection;
        const selectedOption = arr.find((option) => option.selected);
        if (!selectedOption) {
            optionForSelection = arr[offset > 0 ? -1 : 0];
        }
        else {
            const selectedOptionIndex = arr.indexOf(selectedOption);
            optionForSelection = arr[selectedOptionIndex + offset];
        }
        if (optionForSelection) {
            const value = optionForSelection.value;
            this.selectValue(value);
        }
        $event.preventDefault();
    }
    selectValue(value) {
        this.scrollToValue(value);
        if (this.optionComponents) {
            this.optionComponents.forEach((selectOptionComponent) => {
                selectOptionComponent.updateSelected(value);
            });
        }
    }
    isEmpty() {
        return this.multiple ? !this.model?.length : !this.model;
    }
    bindOptions() {
        this.optionComponents?.forEach((selectOptionComponent) => {
            selectOptionComponent.setMultiple(this.multiple);
            selectOptionComponent.onSelect = this.onSelect.bind(this);
            if (selectOptionComponent.value != null) {
                this.textByValue[stringifyValue(selectOptionComponent.value)] =
                    selectOptionComponent.contentWrapper?.nativeElement.textContent.trim();
            }
        });
    }
    renderValue(value) {
        if (this.multiple) {
            this.text = (value || [])
                .map((valueItem) => this.textByValue[stringifyValue(valueItem)])
                .join(", ");
        }
        else {
            this.text = this.textByValue[stringifyValue(value)] || "";
        }
        this.changeDetectionRef.detectChanges();
        if (this.optionComponents) {
            const mvalue = !this.multiple && this.optionComponents.length === 1
                ? this.optionComponents.first.value
                : value;
            this.optionComponents.forEach((selectOptionComponent) => {
                selectOptionComponent.updateSelected(mvalue);
            });
        }
    }
    onOpen() {
        if (!this.disabled) {
            if (this.popoverElement) {
                this.popoverElement.style.visibility = "hidden";
            }
            setTimeout(() => {
                this.focused = true;
                this.selectValue(this.model);
                this.tryToUpdateDirection();
                if (this.popoverElement) {
                    this.popoverElement.style.visibility = "visible";
                }
            });
        }
    }
    tryToUpdateDirection() {
        const targetRect = this.selectElement?.getBoundingClientRect();
        const viewHeight = window.innerHeight;
        const height = this.popoverElement?.offsetHeight;
        if (height && targetRect) {
            const bottomSpaceAvailable = viewHeight - targetRect.bottom;
            this.directionUp = bottomSpaceAvailable < height;
            this.changeDetectionRef.markForCheck();
        }
    }
    onClose() {
        if (!this.disabled) {
            this.focused = false;
            this.selectValue(this.model);
            if (this.selectInput) {
                this.selectInput.nativeElement.value = this.text;
            }
            if (this.popoverElement) {
                this.popoverElement.style.visibility = "hidden";
            }
            this.blur.emit(this.model);
        }
    }
    onSelect(value) {
        if (!this.multiple) {
            this.scrollToValue(value);
        }
        if (!isEqual(this.model, value)) {
            this.writeValue(value);
            this.change.emit(value);
            this.onChange(this.model);
        }
    }
    scrollToValue(value) {
        const popover = this.popoverComponent?.elementRef.nativeElement;
        const list = popover.querySelector(".mdl-list");
        const optionComponent = this.optionComponents?.find((o) => o.value === value);
        const optionElement = optionComponent
            ? optionComponent.contentWrapper?.nativeElement
            : null;
        const selectedItemElem = optionElement?.parentElement;
        if (list && selectedItemElem) {
            const computedScrollTop = selectedItemElem.offsetTop -
                list.clientHeight / 2 +
                selectedItemElem.clientHeight / 2;
            list.scrollTop = Math.max(computedScrollTop, 0);
        }
    }
}
MdlSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlSelectComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
MdlSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: MdlSelectComponent, selector: "mdl-select", inputs: { disabled: "disabled", autocomplete: "autocomplete", label: "label", placeholder: "placeholder", multiple: "multiple", isFloatingLabel: ["floating-label", "isFloatingLabel"] }, outputs: { change: "change", blur: "blur", inputChange: "inputChange" }, host: { listeners: { "keydown": "onKeyDown($event)", "keyup": "onKeyUp($event)" }, properties: { "class.mdl-select": "this.isMdlSelect", "class.has-placeholder": "this.isPlaceholder", "class.mdl-select--floating-label": "this.isFloatingLabel" } }, providers: [MDL_SELECT_VALUE_ACCESSOR], queries: [{ propertyName: "optionComponents", predicate: MdlOptionComponent }], viewQueries: [{ propertyName: "selectInput", first: true, predicate: ["selectInput"], descendants: true, static: true }, { propertyName: "popoverComponent", first: true, predicate: MdlPopoverComponent, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div\n  [class.is-dirty]=\"isDirty()\"\n  [class.is-disabled]=\"disabled\"\n  [class.is-focused]=\"popoverComponent?.isVisible || focused\"\n  class=\"mdl-textfield is-upgraded\"\n>\n  <span (focus)=\"onFocus($event)\" [attr.tabindex]=\"!disabled ? 0 : null\">\n  </span>\n  <input\n    #selectInput\n    (change)=\"$event.stopPropagation()\"\n    (click)=\"toggle($event)\"\n    (focus)=\"onInputFocus()\"\n    [attr.id]=\"textfieldId\"\n    [placeholder]=\"placeholder ? placeholder : ''\"\n    [readonly]=\"disabled || !autocomplete\"\n    [value]=\"text\"\n    class=\"mdl-textfield__input\"\n    tabindex=\"-1\"\n  />\n  <span (click)=\"toggle($event)\" class=\"mdl-select__toggle material-icons\">\n    keyboard_arrow_down\n  </span>\n  <label [attr.for]=\"textfieldId\" class=\"mdl-textfield__label\">{{\n    label\n  }}</label>\n  <span class=\"mdl-textfield__error\"></span>\n  <mdl-popover\n    #popover\n    [class.direction-up]=\"directionUp\"\n    [class.mdl-popover--above]=\"autocomplete\"\n    [hide-on-click]=\"!multiple\"\n    [style.minWidth.%]=\"100\"\n    tabindex=\"-1\"\n  >\n    <div class=\"mdl-list mdl-shadow--6dp\">\n      <ng-content *ngIf=\"popoverComponent?.isVisible\"></ng-content>\n    </div>\n  </mdl-popover>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MdlPopoverComponent, selector: "mdl-popover", inputs: ["hide-on-click", "mdl-popover-position"], outputs: ["onShow", "onHide"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: "mdl-select", encapsulation: ViewEncapsulation.None, providers: [MDL_SELECT_VALUE_ACCESSOR], template: "<div\n  [class.is-dirty]=\"isDirty()\"\n  [class.is-disabled]=\"disabled\"\n  [class.is-focused]=\"popoverComponent?.isVisible || focused\"\n  class=\"mdl-textfield is-upgraded\"\n>\n  <span (focus)=\"onFocus($event)\" [attr.tabindex]=\"!disabled ? 0 : null\">\n  </span>\n  <input\n    #selectInput\n    (change)=\"$event.stopPropagation()\"\n    (click)=\"toggle($event)\"\n    (focus)=\"onInputFocus()\"\n    [attr.id]=\"textfieldId\"\n    [placeholder]=\"placeholder ? placeholder : ''\"\n    [readonly]=\"disabled || !autocomplete\"\n    [value]=\"text\"\n    class=\"mdl-textfield__input\"\n    tabindex=\"-1\"\n  />\n  <span (click)=\"toggle($event)\" class=\"mdl-select__toggle material-icons\">\n    keyboard_arrow_down\n  </span>\n  <label [attr.for]=\"textfieldId\" class=\"mdl-textfield__label\">{{\n    label\n  }}</label>\n  <span class=\"mdl-textfield__error\"></span>\n  <mdl-popover\n    #popover\n    [class.direction-up]=\"directionUp\"\n    [class.mdl-popover--above]=\"autocomplete\"\n    [hide-on-click]=\"!multiple\"\n    [style.minWidth.%]=\"100\"\n    tabindex=\"-1\"\n  >\n    <div class=\"mdl-list mdl-shadow--6dp\">\n      <ng-content *ngIf=\"popoverComponent?.isVisible\"></ng-content>\n    </div>\n  </mdl-popover>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }]; }, propDecorators: { disabled: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], multiple: [{
                type: Input
            }], change: [{
                type: Output
            }], blur: [{
                type: Output
            }], inputChange: [{
                type: Output
            }], selectInput: [{
                type: ViewChild,
                args: ["selectInput", { static: true }]
            }], popoverComponent: [{
                type: ViewChild,
                args: [MdlPopoverComponent, { static: true }]
            }], optionComponents: [{
                type: ContentChildren,
                args: [MdlOptionComponent]
            }], isMdlSelect: [{
                type: HostBinding,
                args: ["class.mdl-select"]
            }], isPlaceholder: [{
                type: HostBinding,
                args: ["class.has-placeholder"]
            }], isFloatingLabel: [{
                type: HostBinding,
                args: ["class.mdl-select--floating-label"]
            }, {
                type: Input,
                args: ["floating-label"]
            }], onKeyDown: [{
                type: HostListener,
                args: ["keydown", ["$event"]]
            }], onKeyUp: [{
                type: HostListener,
                args: ["keyup", ["$event"]]
            }] } });

class MdlSelectModule {
    static forRoot() {
        return {
            ngModule: MdlSelectModule,
            providers: [],
        };
    }
}
MdlSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MdlSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.0", ngImport: i0, type: MdlSelectModule, declarations: [MdlSelectComponent, MdlOptionComponent], imports: [CommonModule, MdlPopoverModule], exports: [MdlSelectComponent, MdlOptionComponent] });
MdlSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlSelectModule, providers: [MDL_SELECT_VALUE_ACCESSOR], imports: [CommonModule, MdlPopoverModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, MdlPopoverModule],
                    exports: [MdlSelectComponent, MdlOptionComponent],
                    declarations: [MdlSelectComponent, MdlOptionComponent],
                    providers: [MDL_SELECT_VALUE_ACCESSOR],
                }]
        }] });

/*
 * Public API Surface of select
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MDL_SELECT_VALUE_ACCESSOR, MdlOptionComponent, MdlSelectComponent, MdlSelectModule, SearchableComponent };
